import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import { Modal, Button } from 'react-bootstrap';
import './Quote.css'; // Import CSS for styling

const Quote = () => {
    const form = useRef();
    const [errors, setErrors] = useState({}); // State to store form validation errors
    const [showModal, setShowModal] = useState(false); // State to control the modal visibility

    const sendEmail = async (e) => {
        e.preventDefault();

        // Form validation
        const formFields = ['to_name', 'from_name', 'whatsapp', 'message', 'budget', 'delivery_time'];
        const newErrors = {};
        let hasError = false;
        formFields.forEach((field) => {
            if (!form.current[field].value.trim()) {
                newErrors[field] = 'This field is required';
                hasError = true;
            } else if (field === 'from_name' && !isValidEmail(form.current[field].value)) {
                newErrors[field] = 'Please enter a valid email address';
                hasError = true;
            } else if (field === 'whatsapp' && !isValidWhatsApp(form.current[field].value)) {
                newErrors[field] = 'Please enter a valid WhatsApp number with country code';
                hasError = true;
            } else if (field === 'budget' && !isValidBudget(form.current[field].value)) {
                newErrors[field] = 'Please enter a valid budget (only numbers)';
                hasError = true;
            } else if (field === 'delivery_time' && !isValidDeliveryTime(form.current[field].value)) {
                newErrors[field] = 'Please select a valid delivery time';
                hasError = true;
            }
        });
        setErrors(newErrors);

        if (hasError) return;

        try {
            // If no error, proceed with sending email
            await emailjs.sendForm('service_9a9a28k', 'template_utol96e', form.current, 'zapInyuwITha3mL9L');
            setShowModal(true); // Show modal upon successful submission

            // Clear form fields after submission
            form.current.reset();
        } catch (error) {
            console.error('FAILED...', error);
            // Handle error
            alert('Failed to send email. Please try again later.');
        }
    };

    const isValidEmail = (email) => {
        // Regular expression to validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const isValidWhatsApp = (whatsapp) => {
        // Regular expression to validate WhatsApp number with country code
        const whatsappRegex = /^\+\d{1,14}$/; // Example: +1234567890
        return whatsappRegex.test(whatsapp);
    };

    const isValidBudget = (budget) => {
        // Regular expression to validate budget (only numbers)
        const budgetRegex = /^\$?\d*\.?\d+$/; // Example: $1000 or 1000
        return budgetRegex.test(budget);
    };

    const isValidDeliveryTime = (deliveryTime) => {
        // Regular expression to validate delivery time (only numbers followed by "DAY" or "DAYS")
        const deliveryTimeRegex = /^\d+\s*(DAY|DAYS)$/i; // Example: 7 DAYS
        return deliveryTimeRegex.test(deliveryTime);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <div className="quote-main">
            <div className="quote-container">
                <div className="get-quote-h2">
                    <h2>Get Your Free Quote Now</h2>
                </div>

                <form ref={form} onSubmit={sendEmail}>
                    <div className="input-group">
                        <label htmlFor="to_name">Name:</label>
                        <input type="text" id="to_name" placeholder="Jhon Smith" name="to_name" />
                        {errors.to_name && <span className="error">{errors.to_name}</span>}
                    </div>
                    <div className="input-group">
                        <label htmlFor="from_name">Email:</label>
                        <input type="email" placeholder="Jhon@gmail.com" id="from_name" name="from_name" />
                        {errors.from_name && <span className="error">{errors.from_name}</span>}
                    </div>
                    <div className="input-group">
                        <label htmlFor="whatsapp">WhatsApp Number (with country code):</label>
                        <input type="tel" id="whatsapp" placeholder="+14845691972" name="whatsapp" />
                        {errors.whatsapp && <span className="error">{errors.whatsapp}</span>}
                    </div>
                    <div className="input-group">
                        <label htmlFor="message">Project Requirements:</label>
                        <textarea id="message" placeholder="e.g I need need logo for my business. My brand colors are light pink and orange." name="message" />
                        {errors.message && <span className="error">{errors.message}</span>}
                    </div>
                    <div className="input-group">
                        <label htmlFor="budget">Budget:</label>
                        <input type="text" id="budget" placeholder="$100" name="budget" defaultValue="$" />
                        {errors.budget && <span className="error">{errors.budget}</span>}
                    </div>
                    <div className="input-group">
                        <label htmlFor="delivery_time">Delivery Time:</label>
                        <select id="delivery_time" name="delivery_time">
                            <option value="">Select Delivery Time</option>
                            {Array.from(Array(30).keys()).map((day) => (
                                <option key={day + 1} value={`${day + 1} DAY${day !== 0 ? 'S' : ''}`}>{`${day + 1} DAY${day !== 0 ? 'S' : ''}`}</option>
                            ))}
                        </select>
                        {errors.delivery_time && <span className="error">{errors.delivery_time}</span>}
                    </div>
                    <button type="submit">Submit</button>
                </form>

                <Modal show={showModal} onHide={closeModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Your Request has been Sent Successfully!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>We have received your request. We will contact you very soon through your email or WhatsApp.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default Quote;
